import type { TopLevelBlock, TopLevelBlockEnum } from '@contentful/rich-text-types';
import { BLOCKS } from '@contentful/rich-text-types';

const headingsOrder: TopLevelBlockEnum[] = [
  BLOCKS.HEADING_3,
  BLOCKS.HEADING_4,
  BLOCKS.HEADING_5,
  BLOCKS.HEADING_6,
];

const getCurrentContentUniqueHeadings = (content: TopLevelBlock[]) =>
  content.reduce((accumulator: TopLevelBlockEnum[], current) => {
    if (
      current.nodeType.startsWith('heading') &&
      !accumulator.includes(current.nodeType) &&
      accumulator.length < 4 /* replace only 4 levels of headings */
    )
      accumulator.push(current.nodeType);
    return accumulator;
  }, []);

/**
 * Normalize Headings to a predefined hierarchy.
 *
 * @description
 * As CMs can put anything in RichText fields, the content between entities
 * doesn't always have the same headings for sections.
 * Some use H2, others H3, same case for sub-headings.
 *
 * @note mutates original objects
 */
export const replaceHeadings = (content: TopLevelBlock[]): TopLevelBlock[] => {
  const uniqueHeadings = getCurrentContentUniqueHeadings(content);
  return content.map((item, index) => {
    if (!item.nodeType.startsWith('heading')) return item;
    const currentHeadingUniqueIndex = uniqueHeadings?.indexOf(item.nodeType) || 0;
    // eslint-disable-next-line no-param-reassign
    content[index].nodeType = headingsOrder[currentHeadingUniqueIndex];
    return item;
  });
};
